export * from '@primeuix/themes/aura/carousel';
export { default } from '@primeuix/themes/aura/carousel';
